
import '../music.css';
import { Layout, Row,Col,Card,ConfigProvider } from 'antd';
import React, { Component } from "react";
import es_ES from 'antd/lib/locale/es_ES';
import {IP} from '../components/utils';
import Foot from "../components/Footer" 
import AdminMenu from "../components/AdminMenu"

class AdminTerms extends Component {
  async componentDidMount() {
    const plays = await fetch(IP + 'api/composicion/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_plays = await plays.json();
    if(json_plays['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
  }

  render() {
    const { Content } = Layout;
    return (
      <div className="page-container">
        <div className = "content-wrap">
          <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
              <AdminMenu/>
              <div style={{flexDirection:'column', flex:'1 0 auto', display:'flex'}} >
                <Row >
                  <Col span={24} >
                  <Card title=" Pol&iacute;ticas, t&eacute;rminos y condiciones para participantes y jurados en la Convocatoria Web al Premio de Composición Casa de las Américas" bordered={false}  >
         
         <p>Casa de las Am&eacute;ricas, proporciona una plataforma en l&iacute;nea creando facilidades de comunicaci&oacute;n, acceso a convocatorias, env&iacute;o de obras concursantes, consultas, seguridad y garant&iacute;as para la continuidad de las sucesivas ediciones del Premio Casa.</p>
        <p>Objetivo. Con la aceptaci&oacute;n de esta Pol&iacute;tica, los t&eacute;rminos y condiciones en ella expresados, usted est&aacute; aceptando reglas y principios relacionados con el procesamiento de datos que se aplicar&aacute;n a los concursantes y jurados en las Convocatorias al Premio Casa que, en lo adelante, se promuevan.</p>
        <p>Usted puede acceder a la p&aacute;gina <a  target="_blank" href="https://premiocasa.cu/composicion">https://premiocasa.cu/composicion</a>. Y, una vez aceptadas las pol&iacute;ticas, inscribirse como concursante cumpliendo los requisitos y aportando la informaci&oacute;n que la p&aacute;gina le va demandando.</p>
        <p>I. Est&aacute;ndares de Participaci&oacute;n.</p>
        <p>Si se ha inscrito como concursante est&aacute; aceptando,</p>
        <ol>
        <li>Que la(s) obra(s) que carga en el sitio se considerar&aacute;n obra(s) en concurso, garantizando que es el autor de todo su contenido, que cumple con los formatos y requisitos de la convocatoria y que autoriza a Casa de las Am&eacute;ricas a reenviar los archivos a todos los miembros del jurado.</li>
        <li>&nbsp;Que no infringe ning&uacute;n derecho de propiedad intelectual, y que libera a Casa de las Am&eacute;ricas de cualquier reclamaci&oacute;n de terceros que tenga relaci&oacute;n con el derecho de autor o los derechos de intimidad y protecci&oacute;n de datos.</li>
        <li>&nbsp;&nbsp;Que, una vez cargada(s) la obra(s) en el sitio, no podr&aacute; realizar personalmente ninguna modificaci&oacute;n. Para registrar&nbsp; cambios o cancelaciones debe dirigir su solicitud al email  dirmusica@casa.cult.cu. &nbsp;</li>
        <li>Que la(s) obra(s) que presente a concurso, estar&aacute;n identificadas con el nombre del autor o seud&oacute;nimo. Los datos personales que incluya en su inscripci&oacute;n no ser&aacute;n de dominio del jurado y s&oacute;lo tendr&aacute; acceso a esos datos personas autorizadas con niveles de acceso y contrase&ntilde;as individuales.</li>
        <li>Que autoriza a Casa de las Am&eacute;ricas a administrar sus datos personales, as&iacute; como toda la informaci&oacute;n que de la(s) obra(s) concursante(s) env&iacute;e, para los fines del concurso y con los l&iacute;mites establecidos en la Convocatoria.</li>
        <li>Que usted ha aceptado los t&eacute;rminos de la Convocatoria &iacute;ntegramente.</li>
        </ol>
        <p>Si ha sido seleccionado como jurado y da su consentimiento, est&aacute; aceptando:</p>
        <ol>
        <li>Que recibir&aacute; las obras en concurso que sean puestas a su disposici&oacute;n en la p&aacute;gina <a href="">https://premiocasa.cu/composicion/jurado</a> identific&aacute;ndose con la contrase&ntilde;a que le sea suministrada por los administradores.</li>
        <li>Que ser&aacute; depositario de esas obras y se abstendr&aacute; de utilizar las mismas para fines distintos o ajenos al concurso, quedando prohibida su comunicaci&oacute;n p&uacute;blica y cualquier acto de divulgaci&oacute;n de todo o parte de las mismas, con excepci&oacute;n de los intercambios entre los miembros del jurado con los que participe.</li>
        <li>Que mantendr&aacute; total confidencialidad sobre los datos a los que tenga acceso por raz&oacute;n del concurso, as&iacute; como sobre las discusiones que en relaci&oacute;n con las obras se suscite.</li>
        <li>Que una vez concluidas las deliberaciones y emitida el Acta del jurado, destruir&aacute; los archivos y datos sobre los autores que haya recibido para la realizaci&oacute;n de este encargo.</li>
        </ol>
        <p>Casa de las Am&eacute;ricas se compromete a:</p>
        <ol>
        <li>Proteger la integridad de las obras depositadas antes y durante el concurso.</li>
        <li>Destruir los archivos una vez entregados los premios, exceptuando las obras galardonadas que ser&aacute;n conservadas y protegidas.</li>
        <li>En caso de obras no premiadas, que hayan sido recomendadas por el jurado o sean de inter&eacute;s para la Casa, se conservar&aacute;n y proteger&aacute;n, previa comunicaci&oacute;n con sus autores.</li>
        <li>Compartir las obras concursantes s&oacute;lo con los jurados que correspondan en cada caso.</li>
        <li>Tratar con total confidencialidad los datos personales de los autores y darlos a conocer p&uacute;blicamente solo en caso de ser galardonados.</li>
        <li>Incorporar al directorio de la Casa, los datos personales de los participantes s&oacute;lo para el env&iacute;o de informaciones y comunicaci&oacute;n institucional, salvo que el concursante disponga expresamente lo contrario.</li>
        </ol>
        <p>Usar, procesar, trasmitir y almacenar la informaci&oacute;n que reciba en raz&oacute;n del concurso bajo los principios de legalidad, propiedad y necesidad.</p>
        <p>Los archivos que contengan las obras e informaciones del concurso ser&aacute;n custodiados, protegidos y administrados por el &aacute;rea de Inform&aacute;tica de la Casa de las Am&eacute;ricas y tendr&aacute;n acceso s&oacute;lo los organizadores del Premio Casa.</p>
                    
           
        </Card>
                  </Col>
                </Row>
              </div>
            </Layout>
          </ConfigProvider>
        </div>
        <div >
          <Foot admin={true}/>
        </div>
    </div>
    );
  }
}
export default AdminTerms;


